/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { BcsFlag } from "../unleash";

export const ConfigBucketStorage = {
  config_bucket_dev_genesis_announcement: new Rox.RoxString(
    "https://storage.googleapis.com/dev-genesis-announcement"
  ),
  config_bucket_dev_genesis: new Rox.RoxString(
    "https://storage.googleapis.com/dev-genesis"
  ),
  config_bucket_stg_genesis: new Rox.RoxString(
    "https://storage.googleapis.com/stg-genesis"
  ),
  config_bucket_prd_genesis: new Rox.RoxString(
    "https://storage.googleapis.com/prd-genesis"
  ),
  config_bucket_bank_logo: new Rox.RoxString(
    process.env.VUE_APP_LOGO_BANK_URL ||
      "https://storage.googleapis.com/dev-genesis/bank-logo/"
  ),
  config_migrate_bucket: new Rox.Flag(false)
};

const BcsConfigBucketStorage = {
  config_bucket_template_files: new BcsFlag.JSONFlag({
    account:
      "https://prd-genesis.s3.ap-southeast-1.amazonaws.com/bulk/template/template_account_15102026.csv",
    customer_management:
      "https://dev-genesis-announcement.s3.ap-southeast-1.amazonaws.com/template/Upload+Customer-EN.csv",
    bulk_booking_retail:
      "https://dev-genesis.s3.ap-southeast-1.amazonaws.com/bulk-booking-retail-en.xlsx",
    bulk_booking_client:
      "https://dev-genesis-announcement.s3.ap-southeast-1.amazonaws.com/template/Template+booking+klien+-+EN.xlsx"
  })
};

export const ConfigBucketTemplateFiles = BcsConfigBucketStorage;
export const configBucketTemplateFiles =
  BcsConfigBucketStorage.config_bucket_template_files;

export function initConfigBucketStorage() {
  Rox.register("configBucketStorage", ConfigBucketStorage);
  BcsFlag.register("configBucketStorage", BcsConfigBucketStorage);
}
